import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="bg-green-700 p-4 text-white shadow-md fixed w-full z-10 top-0">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-white">
          Armant Touche
        </div>
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-white focus:outline-none">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>
        <div className={`flex flex-col md:flex-row md:space-x-4 ${isOpen ? 'block' : 'hidden'} md:block`}>
          <Link to="/" className="px-4 py-2 rounded hover:bg-lime-600 hover:text-gray-400 transition-colors duration-300">
            aboutMe
          </Link>
          <Link to="/blogs" className="px-4 py-2 rounded hover:bg-lime-600 hover:text-gray-400 transition-colors duration-300">
            blogs
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
